module.exports = __webpack_public_path__ + "static/service1-b5f2976c67fc975aacafa034695cccb9.png";